<template>
    <div class="container">
        <div class="login">
            <div class="login-body">
                <form @submit.prevent="login">
                    <div class="login-header">
                        <div class="block-logo">
                            <img class="logo" src="../../assets/logo.svg" :alt="$t('main_label')">
                        </div>
                        <h1>{{$t('auth.main_label')}}</h1>
                    </div>
                    <div class="login-inputs">
                        <input class="login-input login-error" v-if="err" v-model="error" type="text" readonly>
                        <input class="login-input" v-model="username" type="text" :placeholder="$t('auth.user_label')">
                        <input class="login-input" v-model="password" type="password" :placeholder="$t('auth.pwd_label')">
                    </div>
                    <div class="login-buttons">
                        <router-link :to="'/sign/restore'" class="login-link">{{$t('auth.f_pwd_label')}}</router-link>
<!--                        &nbsp;-->
<!--                        {{$t('auth.or_label')}}-->
<!--                        &nbsp;-->
<!--                        <router-link :to="'/sign/up'" class="login-link">{{$t('auth.create_acc_label').toLowerCase()}}</router-link>-->
                    </div>
                    <div class="login-buttons">
                        <button class="login-button" type="submit">{{$t('auth.sign_in_label')}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      username: 'demo',
      password: 'demo',
      err: false
    }
  },
  computed: {
    ...mapGetters({
      appStatus: 'appStatus',
      error: 'appError'
    })
  },
  methods: {
    ...mapActions(['authRequest']),
    login () {
      const { username, password } = this
      this.authRequest({ username, password }).then(() => {
        this.$router.push({name: 'Quick'})
      }).catch(error => {
        this.err = error.error === 'true'
      }).finally(() => {
        this.password = ''
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/Login.vue